'use client'

import { StatCard } from './StatCard'
import type { LucideIcon } from 'lucide-react'

interface StatItem {
  icon: LucideIcon
  label: string
  value: number
  href?: string
  highlight?: boolean
  color?: 'blue' | 'amber' | 'green' | 'red' | 'purple'
  subLabel?: string
  zeroLabel?: string
  miniCtaLabel?: string
}

interface StatsGridProps {
  stats: StatItem[]
  columns?: 2 | 3 | 4 | 5
  className?: string
}

export function StatsGrid({ stats, columns = 5, className = '' }: StatsGridProps) {
  const gridCols: Record<NonNullable<StatsGridProps['columns']>, string> = {
    // ✅ 기본은 모바일 1열 (잘림/찌그러짐 방지)
    2: 'grid-cols-1 sm:grid-cols-2',
    3: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3',
    4: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4',
    // ✅ 5개 KPI는 모바일 1열 → sm 2열 → lg 5열이 가장 자연스러움
    5: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-5',
  }

  return (
    <div className={`grid gap-4 ${gridCols[columns]} ${className}`}>
      {stats.map((stat) => (
        <StatCard key={`${stat.label}-${stat.href ?? 'nohref'}`} {...stat} />
      ))}
    </div>
  )
}
